export default __webpack_public_path__ + "static/images/jennie_08.png";